// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-6Fs0","content":"styles_content__aovKi"};